import globalAxios from 'axios';
import { getEnv } from '../env/environment.js';
import { DefaultApi } from '../generated/shop-api/api.js';
import { Configuration } from '../generated/shop-api/configuration.js';

let shopApi;
const getShopApi = (stage) => {
    if (!shopApi) {
        shopApi = new DefaultApi(new Configuration({ basePath: getEnv(stage).CHECKOUT_API_BASE_PATH }), undefined, globalAxios);
    }
    return shopApi;
};
const getSid = async (stage) => {
    return (await getShopApi(stage).getSid({ headers: { 'x-caller': 'cart-provider' } })).data;
};

export { getSid };
//# sourceMappingURL=shopService.js.map
